import { useState } from 'react';
import { ReactComponent as SendSvg } from '../../../assets/svg/mail-send-email.svg';
import { ReactComponent as LoadingSvg } from '../../../assets/svg/loading-half-status.svg';
import CoachReply from './coachReply';
import UserReply from './userReply';
import request from '../../../lib/request';

const Reply = ({ messageId, replies, user, getMessageReplies, getMessage }) => {
  const [newReply, setNewReply] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChangeNewReply = (e) => {
    setNewReply(e.target.value);
  };

  const sendNewReply = async () => {
    try {
      setLoading(true);
      const coachId = user.programs[0]?.program?.coachId;

      if (!coachId) {
        return;
      }

      const { result } = await request.post(`/message/${messageId}/reply`, {
        content: newReply,
        coachId,
      });

      setNewReply('');
      await getMessage({ next: false });
      await getMessageReplies();
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='relative'>
      <div className='space-y-2 px-4 max-h-64 overflow-auto'>
        {replies.map((reply, i) =>
          reply.from === 'COACH' ? (
            <CoachReply
              key={reply.id}
              item={reply}
              index={i}
            />
          ) : (
            <UserReply
              key={reply.id}
              item={reply}
              index={i}
              getMessageReplies={getMessageReplies}
            />
          )
        )}
      </div>
      <div className='flex items-center gap-2 mt-4 px-4'>
        <textarea
          autoFocus
          className='border rounded-xl p-2 flex-1 resize-none'
          rows={1}
          value={newReply}
          onChange={handleChangeNewReply}
        />
        {loading ? (
          <LoadingSvg className='size-4 opacity-50 animate-spin' />
        ) : (
          <SendSvg
            className='size-4'
            onClick={sendNewReply}
          />
        )}
      </div>
    </div>
  );
};

export default Reply;
